export default {
  SET_ZOOM_LIENZO: ({ commit }, transform) => {
    commit("SET_ZOOM", transform);
  },
};
